export default __webpack_public_path__ + "static/media/100_19595.5ab4f1fe.jpg";